// ** React Imports
import { createContext, useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

// ** Axios
import axios from 'axios'

// ** Config
import authConfig from '../../src/configs/auth'

// ** API Helper
import { httpPost } from '../api/dataService'

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  registration: () => Promise.resolve()
}

const AuthContext = createContext(defaultProvider);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(defaultProvider.user);
  const [loading, setLoading] = useState(defaultProvider.loading);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName);

      if (storedToken) {
        setLoading(true);
        try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}${authConfig.meEndpoint}`)

          const userData = window.localStorage.getItem('adminUserData');
          if (userData) {
            setUser(JSON.parse(userData));
          } else {
            throw new Error('User data not found');
          }
        } catch (err) {
          localStorage.clear();
          setUser(null);
          if (authConfig.onTokenExpiration === 'logout') {
            navigate('/login', { replace: true })
          }
        } finally {
          setLoading(false);  
        }
      } else {
        setLoading(false)
        if (authConfig.onTokenExpiration === 'logout' &&  !location.pathname.includes('login')) {
          navigate('/login', { replace: true });
        }
      }
    }

    initAuth();
  }, [])

  const handleLogin = async (params, errorCallback, data) => {
    const response = data

    if (response.error) {
      return errorCallback(response.error)
    }

    const { accessToken, refreshToken, customer: userData } = response.data.data

    if (params.rememberMe) {
      window.localStorage.setItem(authConfig.storageTokenKeyName, accessToken)
      // if(userData.email && userData.email.includes(`@${process.env.REACT_APP_EMAIL_DOMAIN}`)){
      //   window.localStorage.setItem(authConfig.selectedJeweller, userData.jeweller);
      // }
      window.localStorage.setItem('adminRefreshToken', refreshToken)
      window.localStorage.setItem('adminUserData', JSON.stringify(userData))
    }

    setUser(userData)

    const returnUrl = new URLSearchParams(window.location.search).get('returnUrl') || '/Dashboard'
    navigate(returnUrl, { replace: true })
  }

  const handleRegistration = async (params, errorCallback) => {
    const response = await httpPost(authConfig.registerEndpoint, params)

    if (response.error) {
      return errorCallback(response.error);
    }

    const { accessToken, refreshToken } = response.data[0];

    if (params.rememberMe) {
      window.localStorage.setItem(authConfig.storageTokenKeyName, accessToken);
      // if(response.data[0]?.email && response.data[0]?.email.includes(`@${process.env.REACT_APP_EMAIL_DOMAIN}`)){
      //   window.localStorage.setItem(authConfig.selectedJeweller, response.data[0].jeweller);
      // }
      window.localStorage.setItem('adminRefreshToken', refreshToken);
      window.localStorage.setItem('adminUserData', JSON.stringify(response.data[0]));
    }

    setUser(response.data[0]);
    navigate('/', { replace: true });
  }

  const handleLogout = () => {
    setUser(null)
    window.localStorage.clear()
    navigate('/login', { replace: true });
  }

  const values = {
    user,
    loading,
    setUser,
    setLoading,
    login: handleLogin,
    logout: handleLogout,
    registration: handleRegistration
  }

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>
}

export { AuthContext, AuthProvider }
